var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthArticleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9386 7.51962H23.9386C24.1086 7.51962 24.3486 7.83962 24.3086 8.01962V23.7896C24.3086 24.0196 24.1786 24.2096 23.9586 24.2696L1.32864 24.2896C1.02864 24.2896 0.818641 24.0796 0.828641 23.7896V8.01962C0.788641 7.83962 1.02864 7.51962 1.19864 7.51962H16.7686V2.54962C16.7686 2.42962 16.9786 1.94962 17.0586 1.82962C17.8186 0.579615 19.5686 0.489633 20.4886 1.62963C20.6386 1.81963 20.9286 2.35962 20.9286 2.58962V7.51962H20.9386ZM20.1086 4.18963V2.67962C20.1086 2.17962 19.3286 1.64962 18.8586 1.64962C18.3886 1.64962 17.6086 2.14962 17.6086 2.67962V4.18963H20.1086ZM20.1086 5.01962H17.6086V17.0396L18.8586 18.8996L20.1086 17.0396V5.01962ZM1.7286 8.34963L1.6586 8.41964V10.8296L1.7286 10.8996H16.7086L16.7787 10.8296V8.41964L16.7086 8.34963H1.7286ZM20.9386 10.8896H23.4086L23.4786 10.8196V8.40963L23.4086 8.33962H20.9986L20.9286 8.40963V10.8796L20.9386 10.8896ZM16.7787 11.7196H1.66861V23.3896L1.73861 23.4596H23.4186L23.4886 23.3896V11.7196H20.9486V17.2996C20.3286 18.0596 19.8386 19.1896 19.2186 19.8996C19.1386 19.9896 19.0886 20.0596 18.9586 20.0796L4.45865 20.0496C4.23865 19.9296 4.15865 19.6896 4.27865 19.4496C4.30865 19.3996 4.46864 19.2496 4.51864 19.2496H18.0686L16.7986 17.2996V11.7196H16.7787Z",
    fill: "#A797BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30924 14.9497C4.04924 14.6897 4.24924 14.2297 4.61924 14.2197H13.8193C14.3493 14.2797 14.3792 14.9097 13.9092 15.0597H4.45927C4.40927 15.0197 4.34924 14.9897 4.30924 14.9497Z",
    fill: "#A797BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45869 16.7695H13.9086C14.3886 16.8995 14.3487 17.5295 13.8187 17.5895H4.61866C4.12866 17.5295 4.04868 17.0095 4.44868 16.7695H4.45869Z",
    fill: "#A797BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59853 9.32969C6.91853 9.66969 6.47853 10.2897 6.03853 9.94972C5.52853 9.55972 6.21853 8.92969 6.59853 9.32969Z",
    fill: "#A797BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45942 9.23969C5.22942 9.05969 5.17939 10.1297 4.55939 10.0397C4.08939 9.97971 4.10942 9.31969 4.45942 9.23969Z",
    fill: "#A797BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79884 9.23983C3.46884 9.08983 3.53884 9.96985 2.98884 10.0398C2.48884 10.0998 2.35884 9.33983 2.79884 9.23983Z",
    fill: "#A797BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthArticleIcon);
export default __webpack_public_path__ + "static/media/health-article-icon.370a44321aa5d5ba8cf0b892bc93bc28.svg";
export { ForwardRef as ReactComponent };